/* esm.sh - applesauce-common@5.2.0/dist/operations/file-metadata */
export * from "/*applesauce-common@5.2.0/esnext/dist/operations/file-metadata.mjs";
